import { defineMessages } from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'billing.invoices-table.Due Date',
        defaultMessage: 'Due Date'
    },
    billStatus: {
        id: 'billing.invoices-table.Bill Status',
        defaultMessage: 'Bill Status'
    },
    description: {
        id: 'billing.invoices-table.Invoice Item Description',
        defaultMessage: 'Description'
    },
    amount: {
        id: 'billing.invoices-table.Invoice Item Amount',
        defaultMessage: 'Amount'
    },
    chargeName: {
        id: 'billing.invoices-table.Invoice Item Charge Name',
        defaultMessage: 'Charge Name'
    },
    invoiceItemHeld: {
        id: 'billing.invoices-table.Invoice Item Held',
        defaultMessage: 'Invoice Item Held'
    },
    lastPaymentDate: {
        id: 'billing.invoices-table.Last Payment Date',
        defaultMessage: 'Last Payment Date'
    },
    invoiceTotal: {
        id: 'billing.invoices-table.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    paid: {
        id: 'billing.invoices-table.Paid',
        defaultMessage: 'Paid'
    },
    outstanding: {
        id: 'billing.invoices-table.Outstanding',
        defaultMessage: 'Outstanding'
    },
    invoice: {
        id: 'billing.invoices-table.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    pay: {
        id: 'billing.invoices-table.Pay',
        defaultMessage: 'Pay'
    },
    noMatchingPayments: {
        id: 'billing.invoices-table.No matching payments.',
        defaultMessage: 'No matching payments.'
    },
    disputedAmount: {
        id: 'billing.invoices-table.Disputed Amount',
        defaultMessage: 'Disputed Amount'
    }
});
